import TeamEdit from '@/components/Team/TeamEdit';

export default function PrivateTeamTeamIdEditIndexRoute() {
  return <TeamEdit />;
}
